import { serialize } from 'object-to-formdata'
import axiosForGigbaseBiz from '../config'
import { DataResponse } from '../response'
import { BranchFeedContent, SitePreview } from 'types/branch_feed_content'
import { mergeURL } from './lib'

const resource = 'branch_feed_contents'

type IndexParams = {
  page?: number
  limit?: number
}

export type createParams = {
  body: string
  images: (File | undefined)[]
  site_preview: SitePreview | undefined
}

export const requests = {
  fetchIndex: async ({ page, limit }: IndexParams) => {
    return axiosForGigbaseBiz.get<DataResponse<BranchFeedContent[]>>(resource, {
      params: {
        page,
        limit,
      },
    })
  },
  create: async (params: createParams) => {
    return axiosForGigbaseBiz.post<DataResponse<BranchFeedContent>>(
      resource,
      serialize(params),
    )
  },
  delete: async (id: number) => {
    return axiosForGigbaseBiz.delete<DataResponse>(
      mergeURL(resource, id.toString()),
    )
  },
}
